import StakeHolderMap from '@/modules/map/StakeholderMap'

const MapPage = () => {
  return <StakeHolderMap />
}

export default MapPage